import { env } from '../constants/env-config';

// What the planner screen needs to show a country's tax (ADR-0014). The backend keeps access and its own
// constants; rounding here must match the backend's, which the parity corpus proves (case 13-half-up-on-the-kopeck).
export const JURISDICTIONS = {
  UA: {
    residency: 'UA',
    declarationCurrency: 'UAH',
    currencySymbol: '₴',
    taxTypes: ['PIT', 'MILITARY_LEVY'],
    rounding: { scale: 2, mode: 'HALF_UP' },
    lossCarryForwardRuleKey: 'ua.loss_carry_forward',
    disclaimerKeys: ['not_investment_advice', 'no_liability_after_sale', 'buyback', 'no_sale_commission_no_withholding'],
  },
};

// The build's jurisdiction follows its language; a build of a country without a planner never reaches SCR-02 (AC-30).
const BY_LANGUAGE = { ua: 'UA' };

export const jurisdiction = JURISDICTIONS[BY_LANGUAGE[env.LANGUAGE || 'ua']] || JURISDICTIONS.UA;
